import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Breadcrumbs, Button, Input, ScannerCode, Select, SelectResource } from '../../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { getVision } from '../../../../services/auth';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { convertToUppercase, getPreAllocationArea, showMessageToast, updateTextFields, translate, showMessageToastCustom, getDefaultPrint, isNullOrEmpty } from '../../../../utils/util';
import SecurityService from '../../../../services/SecurityService';

const ChangeLocationReading = (props) => {
    let physicalConfirmation = props.location?.state?.physicalConfirmation;
    let twoSteps = props.location?.state?.twoSteps;
    const dataParams = props.history?.location?.state?.dataParams
    var vision = getVision();
    const getDefaultResourceChangeLocation = () => {
        if (vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) {
            var resourceDefault = props.resources.find(i => i.name === '1000');
            return resourceDefault?.resourceId;
        }
        return props.user.resource || ''
    }

    const [loadingForm, setLoadingForm] = useState(false);
    const [locationParts, setLocationParts] = useState({});
    const [change, setChange] = useState({
        barCode: dataParams?.cim.toString() || "",
        cimQuantity: 0,
        location: twoSteps && vision === VISIONS.Jeep ? "TRV" : getPreAllocationArea(vision),
        location2: '',
        print: twoSteps ? ENUMS.ePrintTypes.Logistics.value : getDefaultPrint(vision),
        resourceId: physicalConfirmation ? props.user.resource : getDefaultResourceChangeLocation(),
        amountTag: '',
        mdr: ''
    });

    useEffect(() => {
        updateTextFields();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        props.setTwoSteps([]);
        window.onMessageMobile = function (e) {
            msgAppHandler(e)
        };
        document.addEventListener('message', msgAppHandler);
        return () => {
            document.removeEventListener('message', msgAppHandler);
        };
        // eslint-disable-next-line
    }, []);

    const msgAppHandler = (e) => {
        if (e.data.indexOf('messageType') >= 0) {
            const msg = JSON.parse(e.data);
            if (msg.messageType === 'labelPrinted' && !msg.success) {
                showMessageToastCustom(translate('warning', 'general'), msg.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    }

    const scannerBarCode = (value) => {
        change.barCode = value;
        setChange({ ...change });
    };

    const scannercimQunatity = (value) => {
        change.cimQuantity = value;
        setChange({ ...change });
    };

    const scannerLocation = (value) => {
        changeLocationParts(value)
    };

    const changeLocationParts = (value) => {
        if (value.charAt(0) === "%") {
            value = value.slice(1, value.length)
        }

        let pieces = value.split('.');
        let secondPart = pieces[2];
        let firstPart = pieces[0] + "." + pieces[1];
        let lastPart = pieces.filter((item, index) => index > 2).join(".")

        setLocationParts({
            firstPart,
            secondPart,
            lastPart
        })

        setChange({ ...change, location: value });
    };

    const onChange = (event) => {
        onValueChange(event, change, setChange);
    };

    const convertToUpper = (evt) => {
        convertToUppercase(evt)
        onChange(evt);
    }

    const changeSecondLocation = (evt) => {
        setLocationParts({ ...locationParts, secondPart: evt.target.value })
    }

    const onChangeLocation = (evt) => {
        let value = evt.target.value

        if ((change.location.length < 3 && value.length > 5) && (vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD)) {
            changeLocationParts(evt.target.value)
        } else {
            onChange(evt);
        }
    }

    const setResource = () => {
        if (change.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const resetFields = () => {
        setLoadingForm(true);
        change.barCode = "";
        change.cimQuantity = 0;
        change.location = getPreAllocationArea(vision);
        change.location2 = '';
        change.amountTag = '';
        change.mdr = '';
        setChange({ ...change });
        setLoadingForm(false);
        setLocationParts({});
    }

    const onConfirm = () => {
        if (validateInputsRequired("formLocation")) {
            if (!twoSteps && (!props.user?.resourceObj || !props.user?.resourceObj?.resourceId)) {
                return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
            }

            let location = change.location;

            if (!isNullOrEmpty(locationParts.firstPart)) {
                location = locationParts.firstPart;

                if (!isNullOrEmpty(locationParts.secondPart)) {
                    location = location + "." + locationParts.secondPart;
                }

                if (!isNullOrEmpty(locationParts.lastPart)) {
                    location = location + "." + locationParts.lastPart;

                }
            }

            const data = {
                ...change,
                twoSteps: twoSteps,
                printer: props.user?.printer,
                resource: setResource(),
                location: location
            }

            props.sendChangeLocation(data, (response) => {
                if (data.twoSteps) {
                    props.setTwoSteps(response.map((f) => { return f.changeLocation }));
                    props.history.push({ pathname: `../location/twosteps` });
                }
                showMessageToastCustom(translate('general.info'), "Locação realizada com sucesso", 5000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                resetFields()
            })
        }
    }

    return (
        <div>
            <Breadcrumbs id="changeLocation" title={{ icon: twoSteps ? "mdi mdi-arrange-send-backward" : "mdi mdi-clipboard-check-outline", label: "Troca de locação" }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '3px', paddingBlockEnd: '1px' }}>
                            {!loadingForm &&
                                <div id="formLocation" className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding  col s12">
                                        {
                                            !twoSteps &&
                                            <Select
                                                required
                                                id="print"
                                                name="print"
                                                display="name"
                                                label={translate('print-type', 'physical-confirmation')}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={[
                                                    { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                                    { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                                    { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                                ]}
                                                change={(e) => {
                                                    props.setPrintSelect(e.target.value);
                                                    onChange(e);
                                                }}
                                                defaultValue={change.print}
                                            />
                                        }
                                    </div>
                                    {
                                        !physicalConfirmation && !twoSteps &&
                                        <div className="input-field no-padding  col s12">
                                            <SelectResource
                                                loadConfigLaser={vision === VISIONS.Jeep}
                                                required
                                                id="resourceId"
                                                name="resourceId"
                                                value={change.resourceId}
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    <div className="input-field no-padding col s12 m8">
                                        <ScannerCode onScanner={scannerBarCode} />
                                        <Input
                                            required
                                            label={translate('cim-mastercim-cimpallet', 'change-location')}
                                            id="barCode"
                                            name="barCode"
                                            type="text"
                                            leadingzeros={10}
                                            onChange={onChange}
                                            value={dataParams?.cim.toString() || change.barCode}
                                        />
                                    </div>
                                    {(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) && locationParts?.firstPart ? (
                                        <>
                                            <div className="input-field no-padding col s4 m2" style={{ marginRight: 0 }}>
                                                <Input
                                                    required
                                                    label={translate('location', 'change-location')}
                                                    id="firstPart"
                                                    type="text"
                                                    value={locationParts.firstPart}
                                                    readOnly={true}
                                                    disabled
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s3 m2" style={{ marginRight: 0 }}>
                                                <Input
                                                    required
                                                    id="secondPart"
                                                    name="secondPart"
                                                    onChange={changeSecondLocation}
                                                    type="text"
                                                    value={locationParts.secondPart}
                                                    style={{ textAlign: 'center' }}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s5 m2" style={{ marginRight: 0 }}>
                                                <ScannerCode onScanner={scannerLocation} />
                                                <Input
                                                    id="lastPart"
                                                    name="lastPart"
                                                    type="text"
                                                    value={locationParts.lastPart}
                                                    readOnly={true}
                                                    disabled
                                                    style={{ textAlign: 'left' }}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <div className={`input-field no-padding col ${(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) ? 's12 m6' : 's8'}`}>
                                            <Input
                                                id="location"
                                                name="location"
                                                label={translate('location', 'change-location')}
                                                type="text"
                                                onChange={onChangeLocation}
                                                value={change?.location}
                                            />
                                            <ScannerCode onScanner={scannerLocation} />
                                        </div>
                                    )}
                                    <div className={`input-field no-padding col ${(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) ? 's12 m3' : 's3'}`}>
                                        <Input
                                            label="MDR"
                                            id="mdr"
                                            name="mdr"
                                            type="text"
                                            onChange={(e) => {
                                                e.target.value = e.target.value.replace(/\s/g, '');
                                                convertToUpper(e)
                                            }}
                                            value={change.mdr}
                                        />
                                    </div>
                                    <div className={`input-field no-padding col ${(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) ? 's12 m2' : 's6'}`}>
                                        <Input
                                            required
                                            label="Quebra Qtd Peças por Cx"
                                            id="cimQuantity"
                                            name="cimQuantity"
                                            type="number"
                                            value={change?.cimQuantity}
                                            onChange={onChange}
                                        />
                                        <ScannerCode onScanner={scannercimQunatity} />
                                    </div>
                                    {(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) &&
                                        <div className="input-field no-padding col s12 m3">
                                            <Input
                                                label={translate('labels', 'general')}
                                                id="amountTag"
                                                name="amountTag"
                                                type="number"
                                                value={change?.amountTag}
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                </div>
                            }
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        config: state.configReducer.config,
        printSelect: state.physicalConfirmationReducer.printSelect
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendChangeLocation: (location, callback) => {
            dispatch(ChangeLocationService.changeLocation(location, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(ChangeLocationService.setPrintSelect(printSelect));
        },
        setTwoSteps: (data) => {
            dispatch(ChangeLocationService.setTwoSteps(data));
        },
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChangeLocationReading));